var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"bar",style:({ width: _vm.tweenedNumber + 'px' })},[_c('span',[_vm._v(_vm._s(_vm.tweenedNumber.toFixed(0)))])])])}
var staticRenderFns = []

export { render, staticRenderFns }